import { render, staticRenderFns } from "./ListarCategorias.vue?vue&type=template&id=95cb07f6&"
import script from "./ListarCategorias.vue?vue&type=script&lang=js&"
export * from "./ListarCategorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports